import { authService } from '../../_services';
import router from '../../router/index';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
    ? { status: { loggedIn: true }, user }
    : { status: {}, user: null };

export const authentication = {
    namespaced: true,
    state: 
        initialState,
        user: {
            loggedIn: false,
            data: null
        },
    getters: {
        user(state){
            return state.user;
        }
    },
    actions: {
        login({ dispatch, commit }, { email, passwordjwt }) {
            commit('loginRequest', { email });
            authService.login(email, passwordjwt)
                .then(
                    user => {
                        commit('loginSuccess', user);
                        router.push('/');
                    },
                    error => {
                        commit('loginFailure', error);
                        dispatch('alert/error', error, { root: true });
                    }
                );
        },
        logout({ commit }) {
            authService.logout();
            commit('logout');
        },
        fetchUser({ commit }, user) {
            commit('SET_LOGGED_IN', user !== null);
        
            if (user) {
                commit('SET_USER', {
                displayName: user.displayName,
                email: user.email
                });
            } else {
                commit('SET_USER', null);
            }
        },
    },
    mutations: {
        loginRequest(state, user) {
            state.status = { loggingIn: true };
            state.user = user;
        },
        loginSuccess(state, user) {
            state.status = { loggedIn: true };
            state.user = user;
        },
        loginFailure(state) {
            state.status = {};
            state.user = null;
        },
        logout(state) {
            state.status = {};
            state.user = null;
        },

        SET_LOGGED_IN(state, value) {
            state.user.loggedIn = value;
        },
        SET_USER(state, data) {
        state.user.data = data;
        },
    
        //This is for Sidbar trigger in mobile
        IS_SIDEBAR_ACTIVE(state, value) {
            state.isSidebarActive = value;
        },
        //This is for Sidebar toggle in desktop
        TOGGLE_REDUCE_SIDEBAR(state, val) {
            state.isSidebarReduced = val;
        },
        //This is for Themeset
        SET_THEME(state, val) {
            state.theme = val;
        },
        //This is for Theme color
        SET_THEME_COLOR(state, val) {
            state.themeColor = val;
        },
        SET_SIDEBAR_WIDTH(state, width) {
            state.sidebarWidth = width;
        },
    }
};